export const PinIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
        >
            <path
                d="M5.50004 0C3.50307 0 1.87842 1.62465 1.87842 3.6216C1.87842 6.09988 5.11941 9.73815 5.2574 9.89182C5.38701 10.0362 5.6133 10.0359 5.74268 9.89182C5.88066 9.73815 9.12166 6.09988 9.12166 3.6216C9.12162 1.62465 7.49699 0 5.50004 0ZM5.50004 5.44373C4.49531 5.44373 3.67793 4.62633 3.67793 3.6216C3.67793 2.61688 4.49533 1.79949 5.50004 1.79949C6.50475 1.79949 7.32213 2.61689 7.32213 3.62162C7.32213 4.62635 6.50475 5.44373 5.50004 5.44373Z"
                fill="#898989"
            />
        </svg>
    );
};
